import { createContext, useContext, useEffect, useState, useCallback } from "react";
import WorkerService from "@/services/agency/WorkerService";

const WorkerContext = createContext();

export const WorkerProvider = ({ children }) => {
    const [workerObjects, setWorkerObjects] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const refresh = useCallback(() => {
        setIsLoading(true);
        WorkerService.getList()
            .then(data => setWorkerObjects(data))
            .finally(() => setIsLoading(false));
    }, []);

    const softRefresh = useCallback(() => {
        WorkerService.getList().then(data => setWorkerObjects(data));
    }, []);

    useEffect(() => { refresh(); }, []);

    return (
        <WorkerContext.Provider value={{ workerObjects, isLoading, refresh, softRefresh }}>
            {children}
        </WorkerContext.Provider>
    );
};

export const useWorkerContext = () => useContext(WorkerContext);
